<template>
  <main role="main">
    <section>
      <v-container>
        <v-layout row wrap align-center class="shop-layout my-3">
          <v-flex xs6 class="mb-2 pl-4">
            <h2>Filtr <v-icon color="orange" class="filter-img">sort</v-icon></h2>
          </v-flex>
          <!-- <v-flex xs6 class="pr-3">
            <v-btn-toggle mandatory light class="elevation-0 currency-btn right" v-model="mena_toggle">
              <v-btn color="orange" depressed>KČ</v-btn>
              <v-btn color="orange" depressed>EUR</v-btn>
               <v-btn color="orange" depressed>USD</v-btn>
            </v-btn-toggle>
          </v-flex> -->
        </v-layout>
        <v-layout row wrap class="shop-layout mb-20">
          <v-flex xs12 sm4 class="px-3 pb-2">
            <v-text-field
              label="Vyhledávání dle názvu, druhu kovu"
              solo
              hide-details
              append-icon="search"
              v-model="search"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 class="px-3 pb-2">
            <v-select
              label="Zlaté mince"
              solo
              hide-details
              :items="kategorie_items"
              item-value="id"
              item-text="nazev"
              v-model="kategorie"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm4 class="px-3 pb-2">
            <v-select
              label="Řazení"
              solo
              hide-details
              :items="sort_options"
              v-model="sort_value"
              item-value="id"
              item-text="text"
            ></v-select>
          </v-flex>
        </v-layout>
        <!-- <Loader v-if="loading" skin="light"></Loader> -->
        <v-layout row wrap class="shop-layout shop-item__layout" v-if="!loading">
          <v-flex xs12 sm6 md4 class="pa-3" v-for="item in items" :key="'produkt-'+item.id.toString()">
            <div class="shop-item">
              <div class="new-product px-2" v-if="item.akcni_cena">Akční produkt</div>
              <div class="new-product deep-orange" v-else-if="item.top_produkt">TOP produkt</div>
              <div class="new-product" v-else-if="item.novy_produkt">Nový produkt</div>
              <eshop-link :to="{ path: '/produkty/'+item.id }">
                <div class="img-wrap">
                  <img v-if="item.obrazky == null || item.obrazky.length == 0" src="@/assets/images/item.png" alt="Zlato">
                  <img v-else :src="'https://uw-comfort-com-images.s3.eu-west-1.amazonaws.com/' + item.obrazky[0].s3_nazev" alt="Zlato">
                </div>
              </eshop-link>
              <eshop-link :to="{ path: '/produkty/'+item.id }">
                <p class="shop-item__title link-black"><strong>{{item.nazev}}</strong></p>
              </eshop-link>
              <v-layout row wrap align-end class="shop-item__mobile">
                <v-flex xs12 lg5>
                  <p class="shop-item__info">{{item.rozmery}}</p>
                  <p class="shop-item__info">{{item.ryzost}}</p>
                </v-flex>
                <v-flex xs12 lg7>
                  <div class="price-wrap text-xs-left text-lg-right">
                    <div class="price inline-block">
                      <div v-if="item.akcni_cena && item.stara_cena != null && item.stara_cena.toString().length > 0">
                        <strong class="grey--text line-through">{{item.stara_cena | formatMoney}} Kč</strong>
                      </div>
                      <strong class="text-primary" v-for="(c, i) in item.aktualni_ceny" :key="'produkt-'+item.id.toString()+'-pc-'+i.toString()" v-if="c.mena.id==mena">{{c.prodejni_cena | formatMoney}}&nbsp;{{c.mena.zkratka}}</strong>
                      <p class="ma-0">Cena s&nbsp;DPH</p>
                    </div>
                    <div class="inline-block"><v-btn color="orange" class="btn-shadow ma-0" dark icon @click="koupit(item)"><v-icon>shopping_cart</v-icon></v-btn></div>
                  </div>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>

        <v-dialog
          v-model="basketDialog"
          max-width="700px"
          transition="dialog-transition"
          v-if="basketDialog"
        >
          <v-card class="no__padding">
            <v-card-title class="pa-0" :class="{'pt-3 px-3 pb-0': $vuetify.breakpoint.smAndDown}">
              <h2 class="mb-3">{{item.nazev}}</h2>
            </v-card-title>
            <v-card-text class="pa-0 mt-3" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
              <v-layout row wrap align-center>
                <v-flex xs12 sm4 :class="{'pr-3': $vuetify.breakpoint.smAndUp}">
                  <img class="mb-3 img-detail" v-img:group1 v-if="item.obrazky == null || item.obrazky.length == 0" src="@/assets/images/item.png" :alt="item.nazev">
                  <img class="mb-3 img-detail" v-img:group1 v-else :src="'https://uw-comfort-com-images.s3.eu-west-1.amazonaws.com/' + item.obrazky[0].s3_nazev" :alt="item.nazev">
                </v-flex>
                <v-flex xs12 sm8 :class="{'pl-3': $vuetify.breakpoint.smAndUp}">
                  <p>
                    <strong>{{item.kratky_popis}}</strong>
                  </p>
                  <v-layout row wrap align-end>
                    <v-flex xs12 sm9 v-for="(c, i) in item.aktualni_ceny" :key="'aktualni-cena-'+i.toString()" v-if="i==0">
                      <p class="grey--text caption mb-1 bold">Cena s DPH:</p>
                      <strong class="h2 text-primary">{{c.prodejni_cena | formatMoney}} {{c.mena.zkratka}}</strong>
                      <p class="grey--text mb-0 bold fs-14"><span v-for="(c, i) in item.aktualni_ceny" :key="'aktualni-cena-'+i.toString()" v-if="i>0"><span v-if="i>1"> / </span>{{c.prodejni_cena | formatMoney}} {{c.mena.zkratka}}</span></p>
                    </v-flex>
                    <v-flex xs12 sm3 class="d-flex justify-end">
                      <v-text-field
                        class="item-ks"
                        placeholder="Počet"
                        hide-controls
                        hide-details
                        type="number"
                        solo
                        suffix="Ks"
                        v-model="mnozstvi"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="mt-3">
                    <v-btn color="grey lighten-1 elevation-0" class="bold ma-0 mr-3 mt-3" dark block large @click="basketDialog=false">Zrušit</v-btn>
                    <v-btn color="orange elevation-0" class="bold ma-0 mt-3" dark block large @click="addBasket">Přidat do košíku</v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="addBasketDialog"
          max-width="700px"
          transition="dialog-transition"
          v-if="addBasketDialog"
        >
          <v-card>
            <v-card-title class="justify-center pa-0">
              <h2 class="mb-3">Zboží bylo přidáno do košíku.</h2>
            </v-card-title>
            <v-card-text class="pa-0">
              <v-layout row wrap>
                <v-btn color="grey lighten-1 elevation-0" class="bold ma-0 mr-3 mt-3" dark block large @click="addBasketDialog=false">Pokračovat v nákupu</v-btn>
                <button-link color="orange elevation-0" class="bold ma-0 mt-3" dark block large :to="{ path: '/kosik' }">Přejít do košíku</button-link>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-pagination
          v-model="pagination.page"
          :length="pagination.pages"
          v-if="!loading"
        ></v-pagination>
        <!-- <v-layout row wrap class="shop-layout" v-if="!loading">
          <v-flex xs12 class="pa-3">
            <div class="become-dealer">
              <div class="banner">
                <v-layout row wrap align-center>
                  <v-flex xs12 sm6>
                    <h2 class="h1 mb-4">Staňte se obchodníkem</h2>
                    <p class="mb-0">
                      <a href="" class="button">Chci vědět více</a>
                    </p>
                  </v-flex>
                  <v-flex xs12 sm6 class="text-xs-center">
                    <img src="@/assets/images/businessman.png" alt="Obchodník">
                  </v-flex>
                </v-layout>
              </div>
              <div class="border"></div>
            </div>
          </v-flex>
        </v-layout> -->
      </v-container>
    </section>
    <!-- <section class="cta" v-if="!loading">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 md4>
            <h2 class="h1 mb-3">Tvoříme zisk a&nbsp;jistíme lidem jejich hodnoty.</h2>
            <p class="text-gray mb-3">
              <strong>
                Vytvoříme zisk, s&nbsp;kterým zajistíme hodnoty
                a&nbsp;podpoříme úroveň života.
              </strong>
            </p>
            <p class="mb-0">
              <a href="" class="button">Chci vědět více</a>
            </p>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 md5>
            <v-layout row wrap>
              <v-flex xs12 sm6 class="mt-md-50">
                <div class="text-xs-center">
                  <img src="@/assets/images/logo-cc.svg" class="mb-2" alt="Commodity e-shop">
                  <h3 class="mb-2">Commodity e-shop</h3>
                  <p>
                    <a href="#" target="_blank" class="link-black bold">www.commodityklub.cz</a>
                  </p>
                </div>
                <ul class="link-footer link-orange">
                  <li><a href="">Zlaté spoření</a></li>
                  <li><a href="">Stříbrné spoření</a></li>
                  <li><a href="">Jednorázová investice</a></li>
                  <li><a href="">Zlaté slitky</a></li>
                  <li><a href="">Stříbrné slitky</a></li>
                  <li><a href="">Zlaté mince</a></li>
                  <li><a href="">Stříbrné mince</a></li>
                </ul>
              </v-flex>
              <v-flex xs12 sm6 class="mt-md-50">
                <div class="text-xs-center">
                  <img src="@/assets/images/logo-cc.svg" class="mb-2" alt="Commodity klub">
                  <h3 class="mb-2">Commodity klub</h3>
                  <p>
                    <a href="#" target="_blank" class="link-green-text bold">www.commodityklub.cz</a>
                  </p>
                </div>
                <ul class="link-footer link-green">
                  <li><a href="">Novinky</a></li>
                  <li><a href="">Nejnovější články</a></li>
                  <li><a href="">Nejnovější videa</a></li>
                  <li><a href="">Návody</a></li>
                </ul>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </section> -->
  </main>
</template>

<script>
import Base from '../Base'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      loadingTable: true,
      basketDialog: false,
      addBasketDialog: false,
      search: "",
      kategorie: null,
      timeout: null,
      counter: 0,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 12,
        sortBy: "prodejnost",
        totalItems: 0,
        pages: 0
      },
      items: [],
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
      kategorie_items: [],
      mena: null,
      mena_toggle: 0,
      alert: false,
      sort_options: [
        { id: "prodejnost", text: "Nejprodávanější"  },
        { id: "nazev", text: "Dle názvu"  },
        { id: "aktualni_prodejni_cena", text: "Od nejnižší ceny"  },
        { id: "aktualni_prodejni_cena_desc", text: "Od nejvyšší ceny"  },
      ],
      sort_value: "prodejnost",
      item: null,
      mnozstvi: null
    }
  },
  mounted: function() {
    this.kategorie = this.getQueryInt("kategorie");
    this.search = this.getQuery("s");
    this.pagination.page = this.getQueryInt("p") != null ? this.getQueryInt("p") : 1;
    this.load();
    if (window.api.$cookies.get("cc_eshop_mena") !== null) {
      this.mena = parseInt(window.api.$cookies.get("cc_eshop_mena"));
      if (this.mena >= 1 && this.mena <= 3) {
        this.mena_toggle = this.mena - 1;
      }
      else {
        this.mena = 1;
      }
    }
    else {
      this.mena = 1;
    }
  },
  watch: {
    search (v) {
      this.queryList();
      this.setQuery("s", v);
    },
    kategorie (v) {
      this.pagination.page = 1;
      this.setQuery("kategorie", v);
      this.load();
    },
  	pagination: {
  		handler: function(newValue) {
        if (!this.loadingTable) {
          this.load();
          this.setQuery("sort", newValue.sortBy == "nazev" && !newValue.descending ? null : newValue.sortBy);
          this.setQuery("sortd", newValue.sortBy == "nazev" && !newValue.descending ? null : newValue.descending);
          this.setQuery("p", isNaN(newValue.page) || parseInt(newValue.page) == 1 ? null : newValue.page);
        }
  		},
  		deep: true
  	},
    mena_toggle (v) {
      switch (v) {
        case 0:
          this.mena = 1;
          break;
        case 1:
          this.mena = 2;
          break;
        case 2:
          this.mena = 3;
          break;
      }
      window.api.$setCookie("cc_eshop_mena", this.mena.toString(), { expires: 30, path: "/" });
    },
    sort_value (v) {
      switch (v) {
        case "nazev":
          this.pagination.sortBy = "nazev";
          this.pagination.descending = false;
          break;
        case "aktualni_prodejni_cena":
          this.pagination.sortBy = "aktualni_prodejni_cena";
          this.pagination.descending = false;
          break;
        case "aktualni_prodejni_cena_desc":
          this.pagination.sortBy = "aktualni_prodejni_cena";
          this.pagination.descending = true;
          break;
        case "prodejnost":
          this.pagination.sortBy = "prodejnost";
          this.pagination.descending = true;
          break;
      }
    }
  },
  methods: {
    queryList: function() {
      if (!this.loading) {
        if (this.timeout != null)
          clearTimeout(this.timeout);
        this.timeout = setTimeout(function() {
          this.pagination.page = 1;
          this.load();
        }.bind(this), 200)
      }
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("produkty/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        kategorie: this.kategorie
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.kategorie_items = [ { id: null, nazev: "Vše" } ].concat(body.kategorie);
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.pagination.pages = body.sort.pages;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    koupit (p) {
      this.mnozstvi = 1;
      this.item = p;
      this.basketDialog = true;
    },
    addBasket () {
      if (this.mnozstvi > 0) {
        window.API.post("kosik", {
          produkt: parseInt(this.item.id),
          mnozstvi: this.mnozstvi
        }).then(function(body) {
          window.kosik.changed();
          this.basketDialog = false;
          this.addBasketDialog = true;
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      }
    }
  },
  components: {

  }
}
</script>
